import { RootState } from '@app/store/types';

export const isPasswordFinding = (state: RootState): boolean =>
  state.account.password.isPasswordFinding;
export const isPasswordReseting = (state: RootState): boolean =>
  state.account.password.isPasswordReseting;
